import { Component, Input, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Lecture } from '../shared/lecture';
import { LectureUserService } from '../shared/lecture-user.service';

@Component({
  selector: 'app-lecture-enrollment-status',
  templateUrl: './lecture-enrollment-status.component.html'
})
export class LectureEnrollmentStatusComponent implements OnChanges {
  @Input() lecture: Lecture;
  enrollmentObservable: Observable<any>;
  inProgressLecture: boolean;

  constructor(private service: LectureUserService) { }

  ngOnChanges() {
    if (this.lecture) {
      this.enrollmentObservable = this.service.readEnrollment(this.lecture);
      const lecture = Object.assign(new Lecture(), this.lecture);
      this.inProgressLecture = lecture.isInProgress();
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-enrollment-status/lecture-enrollment-status.component.ts